const typography = {
  fontFamily: "Manrope, 'Helvetica Neue', Arial, sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1.2,
  },
  h2: {
    fontWeight: 700,
    fontSize: "1.875rem",
    lineHeight: 1.25,
  },
  h3: {
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: 1.3,
  },
  h4: {
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: 1.35,
  },
  h5: {
    fontWeight: 600,
    fontSize: "1.1rem",
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: 1.45,
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: "0.875rem",
  },
  body1: {
    fontSize: "0.95rem",
  },
  body2: {
    fontSize: "0.875rem",
  },
  caption: {
    fontSize: "0.75rem",
  },
};

export default typography;
